<div class="container">
  <div class="my-3">
    <h3 class="h3">Edit Trainer</h3>
    <p class="text-muted">Edit an existing trainer's information.</p>
  </div>
  <div class="pb-5">
    <app-create-trainer mode="edit" [trainer]="trainer"></app-create-trainer>
  </div>
</div>